import { queryOptions, useQuery } from '@tanstack/react-query';
import { userScopeKey } from '@/hooks/queries/users/use-user';
import { getFuturesAssessmentExplanation } from '@/services/api/futures-assessment-explanation';

export const futuresAssessmentExplanationQueryOptions = (pid: string, date: string) =>
  queryOptions({
    queryKey: [...userScopeKey(pid), 'futures-assessment-explanation', date] as const,
    queryFn: () => getFuturesAssessmentExplanation({ pid, date }),
    // Re-scoring a stored attempt is deterministic, so there is nothing to refetch
    staleTime: Number.POSITIVE_INFINITY,
  });

export const useFuturesAssessmentExplanation = (pid: string, date: string) => useQuery(futuresAssessmentExplanationQueryOptions(pid, date));
